import { useDispatch } from "react-redux"
import { FetchState, getValue, hasValue } from "../Models/Client/FetchState"
import { APIGroundTruthDetailedModel } from "../Models/API/APIGroundTruthModel"
import { useEffect, useMemo } from "react"
import { useAppState } from "./useReduxState"
import { getGroundTruth } from "../Actions/API/AppInstance/AppInstanceBaselineDataActions"
import { useDereference } from "./useDereference"
import { Result } from "../Models/Utility/Result"
import { DataAccess } from "../Models/Client/DataAccess"

export function useGroundTruth(
    appID: string,
    groundTruthID?: string
): FetchState<APIGroundTruthDetailedModel> {
    const dispatch = useDispatch()
    const groundTruthFetch = useAppState(state => {
        if (groundTruthID === undefined) {
            return
        }

        return state.api.baselineData.detailedData[groundTruthID]
    })
    const inputFetch = useDereference(
        getValue(groundTruthFetch)?.input,
        DataAccess.owner
    )
    const outputFetch = useDereference(
        getValue(groundTruthFetch)?.label,
        DataAccess.owner
    )

    useEffect(() => {
        if (groundTruthFetch !== undefined || groundTruthID === undefined) {
            return
        }

        dispatch(getGroundTruth(appID, groundTruthID))
    }, [dispatch, groundTruthFetch, appID, groundTruthID])

    return useMemo(() => {
        if (!hasValue(groundTruthFetch)) {
            return groundTruthFetch
        }

        if (!hasValue(inputFetch)) {
            return inputFetch
        }

        if (!hasValue(outputFetch)) {
            return outputFetch
        }

        return Result.ok({
            ...groundTruthFetch.value,
            input: inputFetch.value,
            label: outputFetch.value
        })
    }, [groundTruthFetch, inputFetch, outputFetch])
}
